import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import StoerkIdAPI from '../../../../redux/stoerkID/StoerkIdAPI';
import useWatchError from '../../../../handlingErrors/useWatchError';
import StoerkIdDeviceItem from './StoerkIdDeviceItem';

export interface StoerkIdListDevicesProps {
  devicesIds: string[] | undefined;
  workspaceId: string;
}
export function StoerkIdListDevices(props: StoerkIdListDevicesProps) {
  const { devicesIds, workspaceId } = props;

  const {
    data: devices,
    isLoading: isLoadingDevices,
    error: errorDevices,
  } = StoerkIdAPI.useGetWorkspaceDeviceUsageQuery(devicesIds);

  useWatchError(errorDevices);
  if (isLoadingDevices)
    return (
      <Box sx={{ m: 2, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  return devices?.length ? (
    <StoerkIdDeviceItem devices={devices} workspaceId={workspaceId} />
  ) : null;
}

export default StoerkIdListDevices;
